import React from 'react';

import SkillsLoader from './SkillsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import Divider from '../../Shared/UI/Divider/components/Divider';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import PageSectionTitle from '../../Shared/UI/PageSectionTitle/components/PageSectionTitle';
import NewUnrecognizedSkillForm from './NewUnrecognizedSkillForm';
import SkillsTable from './SkillsTable';
import SkillsPageController from './SkillsPageController';

import styles from './Skills.module.scss';

const Skills = ({ authenticatedUser }) => {
  return (
    <>
      <SkillsLoader authenticatedUser={authenticatedUser} />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Skills'} />
          <NewUnrecognizedSkillForm />
          <Divider />
          <PageSectionTitle text={'Skills'} />
          <SkillsTable />
          <SkillsPageController />
        </Stack>
      </div>
    </>
  );
};

export default Skills;
